module.exports = __webpack_public_path__ + "img/img10.a0e6fb8b.png";